import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 0.75rem;
  flex-wrap: wrap;
  padding: 0.5rem 0;
  width: auto;
`;

export const Field = styled.div`
  min-width: ${props => props.$minWidth || '200px'};
  flex: 0 0 ${props => props.$minWidth || '200px'};
`;

export const CheckboxField = styled(Field)``;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  align-self: flex-end;
  gap: 0.75rem;
  flex: 0 0 auto;
  margin-top: 0;
  padding-bottom: 0;
`;
